import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

export default function index(){
    return(
        <div className="auth-container">
            <Switch>
                <Route path={`/login`}  exact component={Login}/>
                <Route path={`/forgot-password`} exact component={ForgotPassword}/>
                <Route path={`/reset-password`} exact component={ResetPassword}/>
                <Route path="/" render={()=><Redirect to={("/login?return_url="+encodeURIComponent(document.location.href))}/>}/>
            </Switch>
        </div>
    )
}